import React from 'react';
import KoobButton from '@koob/ui/src/components/KoobButton';
import { ProductTypeEnum } from '@koob/enums';

interface TripHotelCardCtaProps {
  name: string;
  kind?: string;
  selectedType?: string | null;
  isIncluded: boolean;
  isBlocked: boolean;
  onAdd: () => void;
  continueLabel: React.ReactNode;
  selectDayLabel: React.ReactNode;
}

/** Hidden for `kind="itinerary"` — the map itinerary view is read-only. */
export default function TripHotelCardCta({
  name,
  kind,
  selectedType,
  isIncluded,
  isBlocked,
  onAdd,
  continueLabel,
  selectDayLabel,
}: TripHotelCardCtaProps) {
  if (kind === 'itinerary') return null;

  const isSelectingHotel = selectedType === ProductTypeEnum.HOTEL;

  return (
    <KoobButton
      variant="primary"
      onClick={onAdd}
      block
      disabled={!isSelectingHotel || isIncluded || isBlocked}
      // e2e page objects select a hotel by name; the card's accept button
      // carries no distinguishing text on its own.
      data-testid={`select-hotel-${name.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {isSelectingHotel || isIncluded ? continueLabel : selectDayLabel}
    </KoobButton>
  );
}
